import * as React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useState } from "react";
import { styled } from "@mui/material/styles";


const StyledAccordion = styled(Accordion)(({ theme, expanded }) => ({
  backgroundColor: "white",
  color:  "black",
  marginTop: "10px",
}));

const StyledAccordionSummary = styled(AccordionSummary)(({ theme, expanded }) => ({
  backgroundColor: expanded ? "red" : "#F8F8F8",
  color: expanded ? "white" : "black",
  marginTop: "10px",
}));

const StyledExpandMoreIcon = styled(ExpandMoreIcon)(({ theme, expanded }) => ({
  color: expanded ? "white" : "inherit",
}));

const CustomAccordion = ({ sections, isExpanded, onExpand }) => {
  const [activeSection, setActiveSection] = useState(isExpanded ? 0 : null);

  const toggleSection = (index) => {
    const newActiveSection = activeSection === index ? null : index;
    setActiveSection(newActiveSection);
    if (newActiveSection !== null && onExpand) {
      onExpand(index);
    }
  };

  return (
    <div>
      {sections.map((section, index) => (
        <StyledAccordion
          key={index}
          expanded={activeSection === index}
          onChange={() => toggleSection(index)}
        >
          <StyledAccordionSummary
            expandIcon={
              <StyledExpandMoreIcon expanded={activeSection === index} />
            }
            expanded={activeSection === index}
          >
            <Typography fontFamily={"DiodrumRegular"}>
              {section.title}
            </Typography>
          </StyledAccordionSummary>
          <AccordionDetails>{section.content}</AccordionDetails>
        </StyledAccordion>
      ))}
    </div>
  );
};

export default CustomAccordion;